import qs from 'query-string';
import { Product } from './product/types';

export const getProductList = () => {
  let AzarJsProductList = [];
  if (typeof window === 'undefined' || !window.AzarJs || !window.AzarJs.getProductPriceInfoListJson) return [];
  try {
    const json = window.AzarJs.getProductPriceInfoListJson();
    AzarJsProductList = JSON.parse(json);
  } catch (e) {
    return [];
  }

  const { productIds } = qs.parse(window.location.search, {
    arrayFormat: 'comma',
  });

  const productIdsList = typeof productIds === 'string' ? [productIds] : productIds;
  const matchingProduct = AzarJsProductList.filter(
    (product: Product) => productIdsList && productIdsList.includes(product.productId)
  );

  if (matchingProduct.length) return matchingProduct;
  return [];
};
